import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=d2968160&scoped=true&"
import script from "./CollectionDetails.vue?vue&type=script&lang=js&"
export * from "./CollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetails.vue?vue&type=style&index=0&id=d2968160&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2968160",
  null
  
)

export default component.exports